import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { Router } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  EGroupsActions,
  GetGroup,
  GetGroups,
  GetGroupsSuccess,
  GetGroupSuccess,
  RequestAllGroups,
} from './groups.actions';
import { IGroup } from '@interfaces/IGroup';
import { ToastrService } from 'ngx-toastr';
import { GroupsService } from '@services/groups/groups.service';
import { Location } from '@angular/common';
import { QueryParamsService } from '@services/query-params/query-params.service';

@Injectable()
export class GroupsEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _groupsService: GroupsService,
    private _router: Router,
    private _toastr: ToastrService,
    private _location: Location,
    private _qpService: QueryParamsService
  ) {}

  $getGroups = createEffect(
    () => {
      this._store.dispatch(new RequestAllGroups());
      return this._actions$.pipe(
        ofType<GetGroups>(EGroupsActions.GetGroups),
        map(action => action),
        switchMap(action => {
          return this._groupsService.getGroups(action.courseId).pipe(
            map((groups: IGroup[]) => {
              this._store.dispatch(new GetGroupsSuccess(groups));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении групп возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getGroup = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetGroup>(EGroupsActions.GetGroup),
        map(action => action.id),
        switchMap(group_id => {
          return this._groupsService.getGroup(group_id).pipe(
            map((group: IGroup) => {
              this._store.dispatch(new GetGroupSuccess(group));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении группы возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
